export const NAME = 'incidents';